import { initialState as insertionFeature } from '../insertion/insertionFeature'
import { initialState as addressFeature } from '../address/addressFeature'
import { initialState as multimediaFeature } from '../multimedia/multimediaFeature'
import { initialState as messageFeature } from '../message/messageFeature'
import { initialState as flowFeature } from '../flow/flowFeature'
import { initialState as previewFeature } from '../preview/previewFeature'
import { initialState as suggestedTextFeature } from '../suggestedText/suggestedTextFeature'
import { initialState as priceMaximizerFeature } from '../priceMaximizer/priceMaximizerFeature'
import { initialState as valuationFeature } from '../valuation/valuationFeature'
import { initialState as rentIndexFeature } from '../rentIndex/rentIndexFeature'
import { initialState as rentControlFeature } from '../rentControl/rentControlFeature'
import { initialState as formStateFeature } from '../formState/formStateFeature'
import { initialState as errorHandlerFeature } from '../errorHandler/errorHandlerFeature'
import { initialState as contactFeature } from '../contact/contactFeature'
import { initialState as userFeature } from '../user/userFeature'
import { initialState as segmentationFeature } from '../segmentation/segmentationFeature'
import {
  AddressFeatureState,
  ContactState,
  ErrorHandlerState,
  FlowState,
  FormStateFeatureState,
  InsertionState,
  MessageState,
  MultimediaState,
  PreviewState,
  PriceMaximizerState,
  RentIndexState,
  RentControlState,
  ValuationState,
  SegmentationFeatureState,
  SuggestedTextFeatureState,
  UserFeatureState,
} from '../../../@types/state-types'

export default {
  insertionFeature,
  addressFeature,
  formStateFeature,
  multimediaFeature,
  messageFeature,
  flowFeature,
  previewFeature,
  suggestedTextFeature,
  priceMaximizerFeature,
  valuationFeature,
  rentIndexFeature,
  rentControlFeature,
  errorHandlerFeature,
  contactFeature,
  userFeature,
  segmentationFeature,
} as InitState

export type InitState = {
  insertionFeature: InsertionState
  addressFeature: AddressFeatureState
  formStateFeature: FormStateFeatureState
  multimediaFeature: MultimediaState
  messageFeature: MessageState
  flowFeature: FlowState
  previewFeature: PreviewState
  suggestedTextFeature: SuggestedTextFeatureState
  priceMaximizerFeature: PriceMaximizerState
  valuationFeature: ValuationState
  rentIndexFeature: RentIndexState
  rentControlFeature: RentControlState
  errorHandlerFeature: ErrorHandlerState
  contactFeature: ContactState
  userFeature: UserFeatureState
  segmentationFeature: SegmentationFeatureState
}
